import { SchemaMerged } from '../../../../types/IHeader';
import { addTypeElement } from '../functions/parseSchema';

export const aboutUs = (webPage: SchemaMerged): SchemaMerged => {
  return addTypeElement(webPage, ['AboutPage']);
};
